let rng = () => Math.random();

// Math.random() tends to be a fairly weak RNG. This is usually "good enough"
// but we may want to expose better RNG whenever possible.
export function setFirestoreIDGeneratorRNG(fn: () => number): () => number {
    rng = fn;
    return rng;
}

const firestoreCharacters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function generateFirestoreDocumentID(stringSize: number = 20): string {
    let buffer = "";
    while (buffer.length < stringSize) {
        buffer += firestoreCharacters[Math.floor(rng() * firestoreCharacters.length)];
    }
    return buffer;
}
